<template>
  <div
    v-if="!(isOwner && [ 'purchase', 'edit' ].includes(mode))"
    class="absolute-fill d-flex justify-center align-center"
  >
    <div
      v-bind:style="{
        'cursor': mode == 'preview' ? null : 'pointer',
        'pointer-events': mode == 'preview' ? null : 'auto',
        'transform': `scale(${blob.btn.scale || 1})`
      }"
    >
      <v-btn
        v-blur
        class="btn"
        x-large rounded height="56" min-width="56" elevation="6" dark :color="blob.btn.color || 'primary'"
        v-bind="blob.btn.url ? { href: blob.btn.url } : {}"
        target="_blank"
        @click="$emit('click')"
      >
        <span v-if="blob.btn.text" v-bind:class="{ 'mr-1': blob.btn.url }" v-html="blob.btn.text" />
        <v-icon v-if="!blob.btn.form" v-html="mdiOpenInNew" />
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
.btn {
  user-drag: none;
  -webkit-user-drag: none;
}
</style>

<script>
import { mdiOpenInNew } from '@mdi/js';

export default {
  name: 'btn-blob-controls',

  props: [ 'blob', 'isOwner', 'mode' ],

  created() {
    Object.assign(this, { mdiOpenInNew });
  }
}
</script>
